'use strict';

wbApp.controller('ActivitySchedulesCtrl', ['$scope', '$modal', '$timeout', 'messageBoxSvc', 'activitySvc', 
    'semesterSvc', 'activityScheduleSvc', 'securitySvc',
function ($scope, $modal, $timeout, messageBoxSvc, activitySvc, semesterSvc, activityScheduleSvc, securitySvc) {

    $scope.gridOptions = {
        sortInfo: { fields: ['startDate'], directions: ['asc'] },
        // > 992
        columnDefs: [{ field: 'weekNo', displayName: "TXT_LBL_WEEK_NO", width: '70px', sortable: false },
                     { field: 'startDate', displayName: "TXT_LBL_FROM", cellFilter: "date:'shortDate'", width: '80px', sortable: false },
                     { field: 'endDate', displayName: "TXT_LBL_TO", cellFilter: "date:'shortDate'", width: '80px', sortable: false },
                     { field: 'monday', displayName: "TXT_MONDAY", cellFilter: "datePartOccupied", width: '70px', sortable: false },
                     { field: 'tuesday', displayName: "TXT_TUESDAY", cellFilter: "datePartOccupied", width: '70px', sortable: false },
                     { field: 'wednesday', displayName: "TXT_WEDNESDAY", cellFilter: "datePartOccupied", width: '70px', sortable: false },
                     { field: 'thursday', displayName: "TXT_THURSDAY", cellFilter: "datePartOccupied", width: '70px', sortable: false },
                     { field: 'friday', displayName: "TXT_FRIDAY", cellFilter: "datePartOccupied", width: '70px', sortable: false },
                     { field: 'saturday', displayName: "TXT_SATURDAY", cellFilter: "datePartOccupied", width: '70px', sortable: false },
                     { field: 'sunday', displayName: "TXT_SUNDAY", cellFilter: "datePartOccupied", width: '70px', sortable: false },
                     { field: 'notes', displayName: "TXT_LBL_NOTE", cellFilter: "aggregateNotes", sortable: false }
        ],
        noCommandColumn: false
    };

    var activitiesForSemester = [];
    var selectedActivity;

    $scope.semesterID;
    $scope.activityID;
    $scope.activityWeeks = [];
    var first = true;

    function selectFirst() {
        $scope.activityWeeks.$promise.then(function () {           
            $timeout(function () {
                if ($scope.activityWeeks.length > 0) {
                    var week = $scope.activityWeeks[0];
                    week.isSelected = true;

                    $scope.onWeekSelected(week);
                }
            })
        });
    }

    function changeActivity(activityId, realod) {

        selectedActivity = _.find(activitiesForSemester, { 'activityID': activityId });

        if (activityId) {
            $scope.activityWeeks = activityScheduleSvc.getWeeksAsync(
                $scope.semesterID, activityId, realod);

            $scope.activityWeeks.$promise.then(function () {
                _.forEach($scope.activityWeeks, function (w) {
                    w.singlePeriodProgramOnly = !!selectedActivity ? selectedActivity.singlePeriodProgramOnly : false;
                });
            });

            if (first) {
                first = false;
                selectFirst();
            }
        } else {
            $scope.activityWeeks.length = 0;
        }
        $scope.$broadcast('activityScheduleSelectionChanged', { selection: null });
    }

    $scope.onSemesterChange = function (semesterId) {
        activitySvc.getAllBySemesterIDAsync(semesterId).$promise.then(function (activities) {

            activitiesForSemester = activities;

            changeActivity(activities.length > 0 ? activities[0].activityID : null, true);

            $scope.$broadcast('activityScheduleSelectionChanged', { selection: null });
        });
    }

    $scope.onActivityChange = function (activity) {
        changeActivity(activity);

        $scope.$broadcast('activityScheduleSelectionChanged', { selection: null });
        $scope.$broadcast('activitySelectionChanged', {
            activityID: activity,
            activity: selectedActivity
        });
    }

    semesterSvc.getDefaultAsync().then(function (activeSemester) {
        if (activeSemester) {
            $scope.semesterID = activeSemester.id;
            $scope.onSemesterChange($scope.semesterID);
        } else {
            $scope.semesterID = null;
        }
    });

    $scope.scheduleDetailModel;
    $scope.scheduleDetailModelOrig;

    $scope.onRowEdit = function (activityWeeks) {

        var selection = [];
        if (activityWeeks) {
            selection.push(activityWeeks);
        }

        $scope.selectedWeeks = selection;

        detailDialogPromise.$promise.then(function () {
            $scope.activityScheduleDetailError = null;
            detailDialogPromise.$scope.singlePeriodProgramOnly = !!selectedActivity ? selectedActivity.singlePeriodProgramOnly : false;
            detailDialogPromise.show();
        });
    }

    $scope.onScheduleDetailSave = function (data) {
        $scope.activityWeeks = data;
        $scope.selectedWeeks.length = 0;
        detailDialogPromise.hide();

        $scope.$broadcast('activityScheduleSelectionChanged', {
            semesterID: $scope.semesterID,
            activityID: $scope.activityID,
            selection: $scope.selectedWeeks,
            activityWeeks: $scope.activityWeeks
        });

        _.forEach($scope.activityWeeks, function (w) {
            w.singlePeriodProgramOnly = !!selectedActivity ? selectedActivity.singlePeriodProgramOnly : false;
        });
    }

    $scope.onWeekSelected = function (data) {

        var selection = [];
        if (data) {
            selection.push(data);
        }
        $scope.selectedWeeks = selection;

        $scope.$broadcast('activityScheduleSelectionChanged', {
            semesterID: $scope.semesterID,
            activityID: $scope.activityID,
            selection: selection,
            activityWeeks: $scope.activityWeeks
        });
    }

    $scope.tabs = [];
    
    if (securitySvc.isInRole('ActivityReservation')) {
        $scope.tabs.push({
            title: 'TXT_LBL_STUDENTS',
            template: "activities/activity-schedule-tabs/students.html"
        });
    }

    if (securitySvc.isInRole('ActivityInstructor')) {
        $scope.tabs.push({
            title: 'TXT_LBL_INSTRUCTORS',
            template: "activities/activity-schedule-tabs/instructors.html"
        });
    }

    $scope.tabs.activeTab = 0;

    $scope.$watch('tabs.activeTab', function (newValue, oldValue) {
        $scope.$broadcast('activeTabChanged', { activeTab: newValue });
    });


    var detailDialogPromise = $modal({
        templateUrl: 'activities/activity-schedule-detail.html',
        show: false,
        scope: $scope
    });

}]);